// extracted by mini-css-extract-plugin
module.exports = {"container":"_15yMs","labelContainer":"_2NDHE","boxContainer":"_2_7JX","icon":"_214tK","checkMark":"_3iA5N","disabled":"c1ttB"};